import { PRESCRIPTION_STORAGE_KEY_PREFIX } from './constants';

const storageKey = (applicationId: string): string =>
    `${PRESCRIPTION_STORAGE_KEY_PREFIX}${applicationId}`;

export const getStoredPrescriptionId = (applicationId: string): string | null =>
    window.localStorage.getItem(storageKey(applicationId));

export const storePrescriptionId = ({
    applicationId,
    prescriptionId
}: {
    applicationId: string;
    prescriptionId: string;
}): void => {
    window.localStorage.setItem(storageKey(applicationId), prescriptionId);
};

export const clearStoredPrescriptionId = (applicationId: string): void => {
    window.localStorage.removeItem(storageKey(applicationId));
};
